<script setup lang="ts">
// A node's page that lost its node: since when, that it is trying again,
// and why when central says (the node offline). Only a dot in the status
// bar said so before, while the bars went on green, so the page looked as
// if all was well. What is below stays readable, greyed (App), its bars
// hatched from the drop on (store lostAt).
import { computed } from 'vue'
import { useNode } from '../store'
import { clock, dot, dur } from '../util'

const node = useNode()
const name = computed(() => node.config?.node.name || 'the node')
const since = computed(() => dur(Math.max(0, (node.now - node.lostAt) / 1000)))
</script>

<template>
    <div
        class="flex flex-wrap items-center gap-x-3 gap-y-1 border-b border-bad bg-bad/15 px-3 py-2 text-sm"
        role="alert"
        data-testid="lost-banner"
    >
        <span class="inline-flex items-center gap-2 font-semibold text-bad"
            ><span :class="[dot('bad'), 'animate-pulse-dot']" />Lost connection to {{ name }}</span
        >
        <span
            >at <span class="font-mono tabular-nums">{{ clock(node.lostAt, true) }}</span
            >, <span class="font-mono tabular-nums">{{ since }}</span> ago</span
        >
        <span v-if="node.connectError" class="text-fg-2" data-testid="lost-reason">{{ node.connectError }}</span>
        <span class="text-fg-2">Reconnecting… What is below is as it was then, not live.</span>
    </div>
</template>
